import { SERVICE } from '@src/api/types/shared/serviceType';
import TenantRoleGuard from '@src/components/guard/TenantRoleGuard';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import SupportServicesForm from '@src/features/tenant/supportServices/SupportServicesForm';
import TenantWithoutSideBarLayout from '@src/layouts/tenant/TenantWithoutSideBarLayout';

function SupportServicesFormPage() {
  return (
    <TenantRoleGuard
      canRoles={[TENANT_ROLE.ADMIN, TENANT_ROLE.CONTENT]}
      canService={[SERVICE.ENTERPRISE_PORTAL, SERVICE.DX_DIAGNOSIS]}
    >
      <TenantWithoutSideBarLayout>
        <SupportServicesForm />
      </TenantWithoutSideBarLayout>
    </TenantRoleGuard>
  );
}

export default SupportServicesFormPage;
